import {
  LOAD_PERFORMANCE_TEST,
  LOAD_PERFORMANCE_TEST_FAIL,
  LOAD_PERFORMANCE_TEST_SUCCESS,
  LOAD_PERFORMANCES_HISTORY,
  LOAD_PERFORMANCES_HISTORY_FAIL,
  LOAD_PERFORMANCES_HISTORY_SUCCESS,
  LoadPerformancesHistoryFail,
  LoadPerformancesHistorySuccess,
  LoadPerformanceTestFail,
  LoadPerformanceTestSuccess,
  PerformanceAction,
  RUN_PERFORMANCE_TEST,
  RUN_PERFORMANCE_TEST_FAIL,
  RUN_PERFORMANCE_TEST_SUCCESS
} from '../actions';
import {LoadPerformancesHistory, LoadPerformanceTest} from "../actions/performance.action";
import {PerformanceTest} from "../../websites/website/performance/performance-test/performance-test";

export interface IWebsitePerformanceTestState {
  performanceTest: PerformanceTest;
  loading: boolean;
  loaded: boolean;
}

export interface IWebsitePerformanceState {
  historyEntities: {[id: string]: any};
  testEntities: {[id: string]: IWebsitePerformanceTestState};
  loading: boolean;
  loaded: boolean;
}

export interface IPerformanceState {
  entities: {[websiteId: number]: IWebsitePerformanceState};
}

export const initialState: IPerformanceState = {
  entities: {}
};

export function reducer(state: IPerformanceState = initialState, action: PerformanceAction): IPerformanceState {
  let payload: any;

  switch (action.type) {

    case LOAD_PERFORMANCES_HISTORY:
      payload = (<LoadPerformancesHistory>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state.entities[payload],
            historyEntities: {},
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_PERFORMANCES_HISTORY_SUCCESS:
      payload = (<LoadPerformancesHistorySuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            historyEntities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_PERFORMANCES_HISTORY_FAIL:
      payload = (<LoadPerformancesHistoryFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            historyEntities: {},
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_PERFORMANCE_TEST:
      payload = (<LoadPerformanceTest>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            testEntities: {
              ...state.entities[payload.websiteId] && state.entities[payload.websiteId].historyEntities ? state.entities[payload.websiteId].historyEntities : {},
              [payload.performanceTestId]: {
                ...state.entities[payload.websiteId] && state.entities[payload.websiteId].historyEntities ? state.entities[payload.websiteId].historyEntities[payload.performanceTestId] : {},
                loading: true,
                loaded: false
              }
            }
          }
        }
      };

    case LOAD_PERFORMANCE_TEST_SUCCESS:
      payload = (<LoadPerformanceTestSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            testEntities: {
              ...state.entities[payload.websiteId].historyEntities,
              [payload.performanceTestId]: {
                ...state.entities[payload.websiteId].historyEntities[payload.performanceTestId],
                performanceTest: payload.performanceTest,
                loading: false,
                loaded: true
              }
            }
          }
        }
      };

    case LOAD_PERFORMANCE_TEST_FAIL:
      payload = (<LoadPerformanceTestFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            testEntities: {
              ...state.entities[payload.websiteId].historyEntities,
              [payload.performanceTestId]: {
                ...state.entities[payload.websiteId].historyEntities[payload.performanceTestId],
                performanceTest: null,
                loading: false,
                loaded: true
              }
            }
          }
        }
      };

    case RUN_PERFORMANCE_TEST:
      return state;

    case RUN_PERFORMANCE_TEST_SUCCESS:
      payload = (<LoadPerformanceTestSuccess>action).payload;

      let testEntities: {} = state.entities[payload.websiteId].testEntities || {};
      testEntities = {
        ...testEntities,
        [payload.performanceTestId]: {
          ...testEntities[payload.performanceTestId],
          loading: false,
          loaded: true
        }
      };

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            testEntities: testEntities
          }
        }
      };

    case RUN_PERFORMANCE_TEST_FAIL:
      return state;
  }

  return state;
}
